var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEvaluatePractice = function SvgIconEvaluatePractice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41875 17.0942H21.6525C22.9061 17.0942 23.9203 16.0685 23.9203 14.8149L23.9317 2.27922C23.9317 1.02565 22.9061 0 21.6525 0H3.41875C2.16518 0 1.13953 1.02565 1.13953 2.27922V14.8149C1.13953 16.0685 2.16518 17.0942 3.41875 17.0942ZM3.41875 2.27922H21.6525V14.8149H3.41875V2.27922Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0714 18.2338H0V20.513H25.0714V18.2338Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7808 5.16243C13.2195 3.60116 10.701 3.60116 9.1397 5.16243C7.57843 6.72369 7.57843 9.24223 9.1397 10.8035C10.4844 12.1482 12.5585 12.3306 14.1084 11.3391L16.4902 13.7209L17.6982 12.5129L15.3164 10.1311C16.3078 8.58126 16.1369 6.50717 14.7808 5.16243ZM13.5728 9.58412C12.6839 10.473 11.2366 10.473 10.3477 9.58412C9.45879 8.69522 9.45879 7.24791 10.3477 6.35902C11.2366 5.47012 12.6839 5.47012 13.5728 6.35902C14.4617 7.25931 14.4617 8.69522 13.5728 9.58412Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEvaluatePractice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-evaluate-practice.3c59f2fa2b8ecf68458c0b2288d6baee.svg";